import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSlate } from 'slate-react';
import { IconButton } from '@material-ui/core';

import Undo from 'src/assets/icons/rich-text-editor/Undo';
import Redo from 'src/assets/icons/rich-text-editor/Redo';
import ClearFormatting from 'src/assets/icons/rich-text-editor/ClearFormatting';
import { SLATE_ACTIONS } from '../../../const';
import { focusEditor } from '../../../utils';

const getFormatIcon = (action) => {
  const icons = {
    [SLATE_ACTIONS.UNDO]: Undo,
    [SLATE_ACTIONS.REDO]: Redo,
    [SLATE_ACTIONS.CLEAR_FORMAT]: ClearFormatting,
  };
  return icons[action];
};

export const ActionButton = ({ action, className, onClick }) => {
  const Icon = getFormatIcon(action);
  const editor = useSlate();

  const handleFormatClick = useCallback(
    (ev) => {
      ev.preventDefault();
      focusEditor({ editor });
      onClick(action);
    },
    [editor, onClick, action]
  );

  return (
    <IconButton
      className={className}
      onMouseDown={handleFormatClick}
    >
      <Icon />
    </IconButton>
  );
};

ActionButton.propTypes = {
  action: PropTypes.oneOf(Object.values(SLATE_ACTIONS)).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

ActionButton.defaultProps = {
  className: '',
};
